import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f1d947d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product__wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "product container"
}
const _hoisted_3 = { class: "product__content" }
const _hoisted_4 = { class: "content__wrapper" }
const _hoisted_5 = {
  key: 1,
  class: "product__wrapper product__wrapper--loading"
}

import { ref, type Ref, watch, onBeforeMount } from 'vue';
import { useProducts } from '@/store';
import { ProductHeader, ProductImages, ProductInfo, ProductPrice } from '@/components/product/_index';
import PageCrumbs from '@/components/PageCrumbs.vue';
import { IProduct } from '@/services';
import { ICrumbs } from '@/components/_types';
import { useRouter } from 'vue-router';
import { RouteNames } from '@/router';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductPage',
  props: {
    id: null
  },
  setup(__props: any) {

const props = __props as {
  id: IProduct['id']
};



const { isLoaded } = storeToRefs(useProducts());
const { getProductById } = useProducts();
const product = ref<IProduct>();
const crumbs: Ref<ICrumbs[]> = ref([]);

const router = useRouter();

const getProduct = () => {
  const currProduct = getProductById(props.id);
  if (currProduct) { 
    product.value = currProduct; 
    crumbs.value = [
      { id: 1, way: product.value.category },
      { id: 2, way: product.value.brand },
      { id: 3, way: product.value.title },
    ];
  } else router.replace({ name: RouteNames.notFound });
};

watch(isLoaded, (newIsLoaded) => {
  if (newIsLoaded) {
    getProduct();
  }
});

onBeforeMount(() => {
  if (isLoaded.value) {
    getProduct();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_AppSpinner = _resolveComponent("AppSpinner")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_unref(isLoaded) && product.value !== undefined)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createVNode(PageCrumbs, { crumbs: crumbs.value }, null, 8 /* PROPS */, ["crumbs"]),
          _createVNode(_unref(ProductHeader), { product: product.value }, null, 8 /* PROPS */, ["product"]),
          _createElementVNode("section", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(ProductImages), { product: product.value }, null, 8 /* PROPS */, ["product"]),
              _createVNode(_unref(ProductInfo), { product: product.value }, null, 8 /* PROPS */, ["product"])
            ]),
            _createVNode(_unref(ProductPrice), { product: product.value }, null, 8 /* PROPS */, ["product"])
          ])
        ]))
      : (_openBlock(), _createElementBlock("section", _hoisted_5, [
          _createVNode(_component_AppSpinner)
        ]))
  ]))
}
}

})